import numeral from 'numeral';
import { defaultFormatConfigs, FormatsConfigs } from 'ff-shared-components-core';

const rightPad = (s: string, c: string, n: number): string => (s.length < n ? s + c.repeat(n - s.length) : s);

export type FormatType = 'noformat' | 'integer' | 'month' | 'amount';
// export type FormatType = 'noformat' | 'integer' | 'month' | 'taeg' | 'tax3' | 'amount';

export function formatNumber(
	value: number,
	format?: FormatType,
	decimalNumbers = 2,
	suffix?: string,
	undefinedDefault?: string
): string {
	let withDecimalPart = true;
	let noFormat = false;
	let decimalNumbersPart = decimalNumbers;
	switch (format) {
		// cSpell: ignore noformat
		case 'noformat':
			noFormat = true;
			break;
		case 'integer':
			withDecimalPart = false;
			// noFormat = false;
			break;
		case 'month':
			withDecimalPart = false;
			noFormat = true;
			break;
		// case 'taeg':
		// 	// withDecimalPart = true;
		// 	// noFormat = false;
		// 	decimalNumbersPart = 1;
		// 	break;
		// case 'tax3':
		// 	// withDecimalPart = true;
		// 	// noFormat = false;
		// 	decimalNumbersPart = 3;
		// 	break;
		case 'amount':
			withDecimalPart = true;
			// noFormat = false;
			decimalNumbersPart = 2;
			break;
		default:
			// withDecimalPart = true;
			// noFormat = false;
			break;
	}
	let strFormat = '0,0.00';
	if (noFormat) {
		strFormat = '0';
	}
	if (!withDecimalPart) {
		strFormat = '0,0';
	}
	if (withDecimalPart && decimalNumbersPart !== 2) {
		strFormat = `0,0.${rightPad('', '0', decimalNumbersPart)}`;
	}

	if (undefinedDefault && (value === undefined || value === null)) {
		return undefinedDefault;
	}

	return `${numeral(value).format(strFormat)}${suffix ? suffix : ''}`;
}

export const registerNumeral = (language: string, formatConfigs?: FormatsConfigs): void => {
	const formatConfigsValue: FormatsConfigs = formatConfigs === undefined ? defaultFormatConfigs : formatConfigs;

	Object.keys(formatConfigsValue).forEach((elem: string): void => {
		const formatConfigItem = formatConfigsValue[elem];
		numeral.register('locale', `numeral-${elem.toLowerCase()}`, formatConfigItem);
	});

	numeral.locale(`numeral-${language.toLowerCase()}`);
};

export const formatIban = (value: string): string => {
	return value
		.replace(/[^\dA-Z]/g, '')
		.replace(/(.{4})/g, '$1 ')
		.trim();
};
